import { AbstractControl, ValidatorFn } from "@angular/forms";

export class CustomValidator {

    static validateRequiredPeriodos(litCodigo: number): ValidatorFn {

        return (control: AbstractControl): { [key: string]: any } | null => {

            const periodo: number = control.value;
            if (litCodigo != 16 && !periodo) {
               return { requiredPeriodo: true };
            }

            return null;

        }
    }

}
